<template>
  <div>
    <v-dialog
      v-for="dialog in modals"
      :key="dialog.config.component"
      :content-class="dialog.config.params.customClass"
      :value="true"
      v-bind="dialog.config.params"
      @click:outside="dialog.config.params.persistent || reject()">
      <component
        :is="dialog.config.component"
        :key="dialog.config.component"
        v-bind="dialog.config.props"
        @resolve="resolve(dialog.config.component, $event)"
        @reject="reject(dialog.config.component)" />
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'LDialog',
  components: {
    notes: () => import(/* webpackChunkName: "dialog-notes" */ '../dialogs/Notes'),
    verify: () => import(/* webpackChunkName: "dialog-verify" */ '../dialogs/Verify'),
    reminder: () => import(/* webpackChunkName: "dialog-reminder" */ '../dialogs/Reminder'),
    confirmation: () => import(/* webpackChunkName: "dialog-confirmation" */ '../dialogs/Confirmation'),
    'order-detail': () => import(/* webpackChunkName: "dialog-order-detail" */ '../dialogs/OrderDetail'),
    'reassign-patient': () => import(/* webpackChunkName: "dialog-reassign-patient" */ '../dialogs/ReassignPatient'),
    'messages-accounts': () => import(/* webpackChunkName: "dialog-messages-accounts" */ '../dialogs/MessagesAccounts'),
    'user-settings': () => import(/* webpackChunkName: "dialog-user-settings" */ '../dialogs/UserSettings'),
    'create-ftp-account': () => import(/* webpackChunkName: "dialog-create-ftp-account" */ '../dialogs/CreateFtpAccount'),
    'registration-success': () => import(/* webpackChunkName: "dialog-registration-success" */ '../dialogs/RegistrationSuccess'),
    'check-eligibility': () => import(/* webpackChunkName: "dialog-check-eligibility" */ '../dialogs/EligibilityStatusModal'),
    'forgot-password': () => import(/* webpackChunkName: "dialog-forgot-password" */ '../dialogs/PasswordResetModal'),
    'change-password-success': () => import(/* webpackChunkName: "dialog-change-password-success" */ '../dialogs/PasswordResetSuccess'),
    'preview-appointment': () => import(/* webpackChunkName: "dialog-preview-appointment" */ '../dialogs/PreviewAppointment'),
    'cancel-booking': () => import(/* webpackChunkName: "dialog-cancel-booking" */ '../dialogs/CancelBooking'),
    'cancel-globe-med': () => import(/* webpackChunkName: "dialog-cancel-booking" */ '../dialogs/CancelGlobeMed'),
    'choose-clinic-id-for-file': () => import(/* webpackChunkName: "dialog-cancel-booking" */ '../dialogs/ChooseClinicIdForFile'),
    'pharmacies-list': () => import(/* webpackChunkName: "dialog-pharmacies-list" */ '../dialogs/PharmaciesList'),
    'upload-medical-record': () => import(/* webpackChunkName: "dialog-upload-medical-record" */ '../dialogs/UploadMedicalRecord'),
    'list-modal': () => import(/* webpackChunkName: "dialog-list-modal" */ '../dialogs/ListModal'),
    'add-credit-card': () => import(/* webpackChunkName: "add-credit-card" */ '../dialogs/AddCreditCard'),
    'capture-photo-modal': () => import(/* webpackChunkName: "dialog-capture-photo-modal" */ '../dialogs/CapturePhotoModal'),
    'document-modal': () => import(/* webpackChunkName: "dialog-document-modal" */ '../dialogs/DocsModal'),
    'appointment-created': () => import(/* webpackChunkName: "dialog-appointment-created" */ '../dialogs/AppointmentCreated'),
    'schedule-created': () => import(/* webpackChunkName: "dialog-schedule-created" */ '../dialogs/ScheduleCreated'),
    'schedule-not-created': () => import(/* webpackChunkName: "dialog-schedule-created" */ '../dialogs/ScheduleNotCreated'),
    'confirm-exit-payment': () => import(/* webpackChunkName: "dialog-confirm-exit-payment" */ '../dialogs/ConfirmExitPayment'),
    'urgent-modal': () => import(/* webpackChunkName: "dialog-urgent-modal" */ '../dialogs/UrgentModal'),
    'webrtc-settings': () => import(/* webpackChunkName: "dialog-webrtc-settings" */ '../dialogs/WebRTCSettings'),
    'soap-notes': () => import(/* webpackChunkName: "dialog-soap-notes" */ '../dialogs/SoapNotesModal'),
    'video-modal': () => import(/* webpackChunkName: "dialog-video-modal" */ '../dialogs/VideoModal'),
    'photo-modal': () => import(/* webpackChunkName: "dialog-photo-modal" */ '../dialogs/PhotoModal'),
    'create-schedule-modal': () => import(/* webpackChunkName: "dialog-create-update-schedule-modal" */ '../dialogs/CreateUpdateSchedule'),
    'end-videocall-modal': () => import(/* webpackChunkName: "dialog-end-video-call-patient" */ '../dialogs/EndVideoCallPatient'),
    'order-form-modal': () => import(/* webpackChunkName: "dialog-order-form-modal" */ '../dialogs/OrderFormModal'),
    'medical-certificate-modal': () => import(/* webpackChunkName: "dialog-medical-certificate-modal" */ '../dialogs/MedicalCertificateModal'),
    'inventory-modal': () => import(/* webpackChunkName: "dialog-inventory-modal" */ '../dialogs/InventoryModal'),
    'doctor-info-modal': () => import(/* webpackChunkName: "dialog-doctor-info-modal" */ '../dialogs/DoctorInfoModal'),
    'enrollment-modal': () => import(/* webpackChunkName: "dialog-enrollment-modal" */ '../dialogs/EnrollmentModal'),
    'admin-note-modal': () => import(/* webpackChunkName: "dialog-admin-note-modal" */ '../dialogs/AdminNote'),
    'create-update-remote-database': () => import(/* webpackChunkName: "dialog-create-update-remote-database-modal" */ '../dialogs/CreateUpdateRemoteDatabase'),
    'ca-appointment-details': () => import(/* webpackChunkName: "dialog-ca-appointment-details" */ '../dialogs/CAappointmentDetails'),
    'discharge-modal': () => import(/* webpackChunkName: "dialog-discharge-summary" */ '../dialogs/DischargeModal'),
    'insurance-modal': () => import(/* webpackChunkName: "dialog-insurance" */ '../dialogs/InsuranceModal'),
    'fee-group-modal': () => import(/* webpackChunkName: "dialog-fee-group" */ '../dialogs/FeeGroupModal'),
    'discount-code-history-modal': () => import(/* webpackChunkName: "dialog-discount-code-history-modal" */ '../dialogs/DiscountCodeHistory'),
    'create-discount-code-modal': () => import(/* webpackChunkName: "dialog-create-discount-code-modal" */ '../dialogs/CreateDiscountCode'),
    'add-measurement-modal': () => import(/* webpackChunkName: "add-measurement-modal" */ '../dialogs/AddMeasurement'),
    'shuffle-appointment-modal': () => import(/* webpackChunkName: "shuffle-appointment-modal" */ '../dialogs/ShuffleAppointment'),
    'booking-modal': () => import(/* webpackChunkName: "booking-modal" */ '../dialogs/BookingModal'),
    'dependent-form': () => import(/* webpackChunkName: "dependent-form" */ '../dialogs/DependentForm'),
    'newrx-modal': () => import(/* webpackChunkName: "newrx-modal" */ '../dialogs/NewRxModal'),
    'change-plan': () => import(/* webpackChunkName: "newrx-modal" */ '../dialogs/ChangePlan'),
    'change-password': () => import(/* webpackChunkName: "change-password" */ '../dialogs/ChangePassword'),
    'show-edi-report': () => import(/* webpackChunkName: "newrx-modal" */ '../dialogs/ShowEdiReport'),
    invites: () => import(/* webpackChunkName: "dialog-invites" */ '../dialogs/Invites'),
    'injury-intake-modal': () => import(/* webpackChunkName: "dialog-injury-intake-modal" */ '../dialogs/InjuryIntakeDialog'),
    'prescription-dme-modal': () => import(/* webpackChunkName: "dialog-prescription-dme-modal" */ '../dialogs/PrescriptionDmeDialog'),
  },
  data() {
    return {
      modals: [],
      defaultParams: {
        component: '',
        params: {
          width: 600,
          persistent: true,
          customClass: '',
        },
        props: {},
      },
    };
  },
  methods: {
    resolve(componentName, params = null) {
      this.$eventBus.$emit(componentName, { success: true, data: params });
      this.close(componentName);
    },
    reject(componentName, params = null) {
      this.$eventBus.$emit(componentName, { success: false, data: params });
      this.close(componentName);
    },
    close(componentName) {
      const modalIndex = this.modals.findIndex(m => m.config.component === componentName);

      if (modalIndex > -1) {
        this.modals.splice(modalIndex, 1);
      }
    },
  },
  mounted() {
    this.$eventBus.$on('open-dialog', config => {
      const modalParams = {
        component: config.component,
        params: { ...this.defaultParams.params, ...config.params },
        props: { ...this.defaultParams.props, ...config.props },
      };
      this.modals.push({
        config: modalParams,
      });
    });
    this.$eventBus.$on('close-dialog', dialogName => {
      this.close(dialogName);
    });
  },
};
</script>
